import { type Availability, seeded } from "./reliability"

export const DEFERRAL_CATEGORIES = ["A", "B", "C", "D"] as const

export type DeferralCategory = (typeof DEFERRAL_CATEGORIES)[number]

export type Deferral = {
  category: DeferralCategory
  daysLeft: number
  rie: boolean
}

export type Operations = {
  availability: Availability
  overdue: number
  dueSoon: number
  adsToAssess: number
  adsOpen: number
  adsDue: number
  adsOverdue: number
  deferrals: Deferral[]
}

function availabilityOf(roll: number): Availability {
  if (roll < 0.08) return "aog"
  if (roll < 0.16) return "in-check"
  if (roll < 0.22) return "stored"
  return "available"
}

function categoryOf(roll: number): DeferralCategory {
  if (roll < 0.05) return "A"
  if (roll < 0.3) return "B"
  if (roll < 0.8) return "C"
  return "D"
}

function deferral(random: () => number): Deferral {
  const category = categoryOf(random())
  return {
    category,
    daysLeft: Math.floor(random() * 70) - 6,
    rie: category === "B" && random() < 0.4,
  }
}

export function tailOperations(registration: string): Operations {
  const random = seeded(`${registration}:operations`)
  const availability = availabilityOf(random())
  const deferrals =
    availability === "stored"
      ? []
      : Array.from({ length: Math.floor(random() * 2.2) }, () =>
          deferral(random),
        )
  const lapsed = deferrals.filter((item) => item.daysLeft < 0).length
  const expiring = deferrals.filter(
    (item) => item.daysLeft >= 0 && item.daysLeft <= 30,
  ).length
  const adsOverdue = random() < 0.08 ? 1 : 0

  return {
    availability,
    overdue: adsOverdue + lapsed,
    dueSoon: Math.floor(random() * 3) + expiring,
    adsToAssess: random() < 0.2 ? 1 + Math.floor(random() * 2) : 0,
    adsOpen: random() < 0.5 ? 1 : 0,
    adsDue: adsOverdue + (random() < 0.3 ? 1 : 0),
    adsOverdue,
    deferrals,
  }
}
